import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

import {findVideoData, GetRegion2Css, GetRegion2Name} from '../../defines/client.const';
import {VideoHistoryService} from '../../services/video/video-history.service';
import {YoutubeService} from '../../services/youtube/youtube.service';
import {VideoBoxComponent} from './video-box.component';


@Component({
  selector: 'app-video-item',
  templateUrl: './video-item.component.html',
})
export class VideoItemComponent extends VideoBoxComponent {

  public readonly findVideoData = findVideoData;
  protected readonly GetRegion2Css = GetRegion2Css;
  protected readonly GetRegion2Name = GetRegion2Name;

  constructor(
    protected sanitizer: DomSanitizer,
    protected youtube: YoutubeService,
    protected historySvc: VideoHistoryService,
  ) {
    super(sanitizer, youtube, historySvc);
  }

}
